/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Breadcrumb_LabelInputs */

const en_help_breadcrumb_label = /** @type {(inputs: Help_Breadcrumb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where this article is`)
};

const pl_help_breadcrumb_label = /** @type {(inputs: Help_Breadcrumb_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gdzie jest ten artykuł`)
};

/**
* | output |
* | --- |
* | "Where this article is" |
*
* @param {Help_Breadcrumb_LabelInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const help_breadcrumb_label = /** @type {((inputs?: Help_Breadcrumb_LabelInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Breadcrumb_LabelInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_help_breadcrumb_label(inputs)
	return en_help_breadcrumb_label(inputs)
});